import React, { Component } from 'react';
import { goToTop } from 'react-scrollable-anchor'
import Banner from './Banner';
import Contact from './Contact';

class Section extends Component {

    static defaultProps = {
        containerImage: false,
        bulr: false,
        imagePositionX: 'center',
        imagePositionY: 'center',
        bannerTitle: null,
        bannerContent: null,
        bannerHeight: 400,
        imageHeight: 'auto',
        imageWidth: '100%',
        backgroundColor: null,
    }

    componentWillMount() {
        goToTop()
    }

    render() {
        return (
            <div>
                <Banner
                    title={this.props.bannerTitle}
                    content={this.props.bannerContent}
                    blur={this.props.blur}
                    imagePositionX={this.props.imagePositionX}
                    imagePositionY={this.props.imagePositionY}
                    containerImage={this.props.containerImage}
                    backgroundColor={this.props.backgroundColor}
                    image={this.props.banner}
                    imageHeight={this.props.imageHeight}
                    imageWidth={this.props.imageWidth}
                    height={this.props.bannerHeight} />
                {this.props.children}
                {this.props['no-contact'] ?
                    null : <Contact asunto={this.props.asuntoContacto} />
                }
            </div>
        );
    }
}

export default Section;


// WEBPACK FOOTER //
// ./src/layout/Section.js